export default __webpack_public_path__ + "img/d0f3e0158b20531859bb1b529f823501.png";